import { render, staticRenderFns } from "./SiteTopBar.vue?vue&type=template&id=5c0a3682&scoped=true&"
import script from "./SiteTopBar.vue?vue&type=script&lang=js&"
export * from "./SiteTopBar.vue?vue&type=script&lang=js&"
import style0 from "./SiteTopBar.vue?vue&type=style&index=0&id=5c0a3682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a3682",
  null
  
)

export default component.exports